module.exports = __webpack_public_path__ + "img/chp-health.058ed528.png";